import { create } from 'zustand'

export interface Task {
  task_name: string
  display_name: string
  description?: string
  bq_project: string
  bq_dataset: string
}

interface TaskState {
  tasks: Task[]
  selectedTask: string | null
  isLoading: boolean
  
  // Actions
  setTasks: (tasks: Task[]) => void
  setSelectedTask: (taskName: string | null) => void
  setLoading: (isLoading: boolean) => void
}

export const useTaskStore = create<TaskState>((set) => ({
  tasks: [],
  selectedTask: null,
  isLoading: false,

  setTasks: (tasks) => set({ tasks }),
  setSelectedTask: (taskName) => set({ selectedTask: taskName || null }),
  setLoading: (isLoading) => set({ isLoading }),
}))
